import React, { isValidElement, ReactElement, ReactNode } from 'react'

import { Icon } from '@app/components/util'
import { LntIconButton, LntTag } from '@app/components/base'

import { ICON_NAME } from '@app/constants/icon'
import { BUTTON_TYPE, ICON_SIZE, SIZE } from '@app/constants'

import styles from './styles.module.scss'

import type { TagStatus } from '@app/types'
import type { ControlProps } from './types'

const getStatuses = (statuses?: Array<TagStatus | ReactElement>): ReactNode | undefined =>
  statuses?.map((status, index) => {
    if (isValidElement(status)) return status

    return (
      <LntTag
        key={ `${status.value}_${index}` }
        type={ status.type }
      >
        { status.label }
      </LntTag>
    )
  })

const ArrowBlackOutline: React.FC = () => (
  <Icon
    size={ ICON_SIZE }
    name={ ICON_NAME.arrowBack }
  />
)

export const Control: React.FC<ControlProps> = ({ title, statuses, onPushBack }) => {
  const pushBackButton = onPushBack && (
    <LntIconButton
      type={ BUTTON_TYPE.text }
      size={ SIZE.middle }
      className={ styles.control__pushBackButton }
      icon={ <ArrowBlackOutline /> }
      onClick={ onPushBack }
    />
  )

  return (
    <div className={ styles.control }>
      <h6>{ title }</h6>

      { pushBackButton }

      <div className={ styles.control__statuses }>{ getStatuses(statuses) }</div>
    </div>
  )
}
